<template>
  <span class="toggle-switch" :class="{ rightAligned: isRightAligned }">
    <label v-if="label" class="text-label" :for="id">{{ label }}</label>
    <input :id="id" type="checkbox" @change="change">
    <label :for="id" />
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    isRightAligned: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    change(event) {
      if (event.target.checked) {
        this.$emit('checked');
      } else {
        this.$emit('unchecked');
      }
    },
  },
};

</script>

<style lang="scss" scoped>


  .toggle-switch {
    display: flex;
    align-items: center;

    .text-label {
      color: $black;
      margin-right: 1.375rem;
    }
  }

  .toggle-switch.rightAligned {
    justify-content: space-between;
  }

  label {
    margin: 0;
    padding: 0;
  }

  input {
    position: absolute;
    margin-left: -99999999px;
  }

  input:focus + label::before {
    background-color: $primary-50;
    box-shadow: 0 0 0 1px $primary-300;
  }

  input:focus + label::after {
    box-shadow: 0 0 0 1px $primary-300;
    border-radius: 50%;
  }

  input + label {
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 1.75rem;
    height: 1rem;
    border-radius: 50%;
  }

  input + label::before,
  input + label::after {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border: 1px solid transparent;
    top: 0;
    left: 0;
    bottom: 0;
    content: "";
  }

  input + label::before {
    right: 1px;
    border: 1px solid $pearl-300;
    border-radius: 0.5rem;
    transition: all 0.4s;
  }

  input + label::after {
    width: 1rem;
    border: 1px solid $pearl-300;
    border-radius: 1.375rem;
    transition: all 0.4s;
  }

  input:checked + label::before {
    background-color: rgba($primary-500, 0.3);
    border-color: transparent;
  }

  input:checked + label::after {
    margin-left: 0.625rem;
    border-color: transparent;
    background-color: $primary-500;
  }

  @media #{$screen-width-small} {
    input + label {
      width: 2.75rem;
      height: 1.375rem;
      border-radius: 1.375rem;
    }

    input + label::before {
      border-radius: 1.375rem;
    }

    input + label::after {
      width: 1.375rem;
    }

    input:checked + label::after {
      margin-left: 1.325rem;
    }
  }
</style>
